import { useTranslation } from 'react-i18next';
import { useCurrency } from '@/context/CurrencyContext/CurrencyContext';
import { useLocale } from '@/hooks/useLocale';

interface PriceProps {
  amount: number;
  currency?: string;
}

export const Price = ({ amount, currency: currencyProp }: PriceProps) => {
  const { t } = useTranslation();
  const locale = useLocale();
  const { currency: currencyFromContext } = useCurrency();
  const currency = currencyProp || currencyFromContext;

  return (
    <>
      {t('price', {
        amount,
        currency: t(`currency.${currency}`, { defaultValue: currency }),
        formatParams: {
          amount: {
            currency,
            locale,
          },
        },
      })}
    </>
  );
};
